
export const USER_NOTIFICATION = {
  USER_NOTIFICATION_COMMENT: 1,
  USER_NOTIFICATION_HR: 2,
  USER_NOTIFICATION_REMINDER: 3,
  CLIENT_NOTIFICATION_SYSTEM: 4
}



// WEBPACK FOOTER //
// ./src/constants/userNotification.js